import script from "./ThemeChanger.vue?vue&type=script&lang=ts"
export * from "./ThemeChanger.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__